module.exports = __webpack_public_path__ + "static/media/29EUNOG7.a31d7fa9.jpg";